import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { User } from "@/types";

export interface RecoverPasswordResponse {
  message: string;
  data: User;
}

export interface RequestRecoverPassword {
  email: string;
}

async function recoverPassword(
  request: RequestRecoverPassword
): Promise<RecoverPasswordResponse> {
  const response = await httpRequest.post<RecoverPasswordResponse>(
    `/password/email`,
    request
  );
  return response.data;
}

export function useRecoverPasswordMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: recoverPassword,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user"] });
    },
  });
}
